module.exports = __webpack_public_path__ + "img/check-solid.bea71c63.svg";